import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule, MatSelectModule,
    MatTableModule,
    MatTabsModule
} from '@angular/material';
import {MatSliderModule} from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SubventionUtil } from '../../utils/subvention-util';
import { ApiServiceService } from '../../api-service.service';
import { AllLoansComponent } from './all-loans-and-applications/all-loans/all-loans.component';
import { TileFactory } from './all-loans-and-applications/tiles/tile-factory';
import { LoaderModule } from '../../directives/loader.module';
import { StorageService } from '../../service/storage.service';
import { UserIdResolver } from '../../resolvers/user-id.resolver';
import { SubventionService } from '../../service/subvention.service';
import { LoanIdResolver } from '../../loan-sanction/loan-id.resolver';
import { LoanDetailsService } from '../../service/loan-details.service';
import { BorrowerDashboardComponent } from './borrower-dashboard.component';
import { ChannelPartnerService } from '../../service/channel-partner.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonSectionsModule } from '../../views/common/common-sections.module';
import { LoanSanctionComponent } from '../../loan-sanction/loan-sanction.component';
import { BorrowerDashboardRoutingModule } from './borrower-dashboard-routing.module';
import { SubventionPreferenceService } from '../../service/subvention-preference.service';
import { HorizontalLoaderModule } from '../../horizontal-loader/horizontal-loader.module';
import { AllLoansAndApplicationsComponent } from './all-loans-and-applications/all-loans-and-applications.component';
import { DisplayPictureModule } from '../../views/common/display-picture/display-picture.module';
import { PipesModule } from '../../utils/pipes/pipes.module';
import { LoanProgressComponent } from '../../loan-progress/loan-progress.component';
import { BorrowerMenuModule } from './borrower-menu/borrower-menu.module';
import { DisbursedLoanInfoComponent } from './disbursed-loan-info/disbursed-loan-info.component';
import { IndianCurrencyPipe } from '../../utils/pipes/indian-currency.pipe';
import { LoansAndApplicationsSegregator } from './all-loans-and-applications/loans-and-applications-segregator';
import { ActiveApplicationComponent } from './all-loans-and-applications/active-application/active-application.component';
import { DocumentsComponent } from '../../documents/documents.component';
import { PassbookComponent } from '../../passbook/passbook.component';
import { BorrowerDashboardBreadcrumbsComponent } from './breadcrumbs/borrower-dashboard-breadcrumbs.component';
import { BreadcrumbService } from './breadcrumbs/breadcrumb.service';
import {PastApplicationsComponent} from './all-loans-and-applications/past-applications/past-applications.component';
import { TooltipModule } from '../../tooltip/tooltip.module';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentCollectionService } from '../../service/payment-collection.service';
import { PreApprovedLoanOfferComponent } from './pre-approved-loan-offer/pre-approved-loan-offer.component';
import {BankAccountService} from '../../service/bank-account.service';
import {UserAddressModule} from '../../user/user-address/user-address.module';
import {BankAccountModule} from '../../user/bank-details/bank-account.module';
import {PaginationModule} from '../../common/pagination/pagination.module';
import {AllInProgressLoanApplicationsComponent} from './all-loans-and-applications/all-in-progress-loan-applications/all-in-progress-loan-applications.component';
import { LoanService } from '../../service/finzy-flex/loan/loan.service';
import { LoanSuggestedTermTableComponent } from './loan-suggested-term-table/loan-suggested-term-table.component';

@NgModule({
    declarations: [BorrowerDashboardComponent, AllLoansAndApplicationsComponent, AllLoansComponent, LoanSanctionComponent,
        LoanProgressComponent, DisbursedLoanInfoComponent, ActiveApplicationComponent, DocumentsComponent, PassbookComponent,
        BorrowerDashboardBreadcrumbsComponent, PastApplicationsComponent, PreApprovedLoanOfferComponent, AllInProgressLoanApplicationsComponent, LoanSuggestedTermTableComponent],
    imports: [
        CommonModule, CommonSectionsModule, BorrowerMenuModule, BorrowerDashboardRoutingModule, MatTableModule, MatTabsModule,
        MatDialogModule, MatProgressSpinnerModule, MatButtonModule, MatPaginatorModule, HorizontalLoaderModule, LoaderModule,
        DisplayPictureModule, PipesModule, TooltipModule, SharedModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatInputModule,
        MatButtonModule, MatSliderModule, UserAddressModule, BankAccountModule, MatSelectModule, PaginationModule, MatIconModule
    ],
    providers: [UserIdResolver, TileFactory, ApiServiceService, StorageService, LoanDetailsService, SubventionService,
        SubventionPreferenceService, ChannelPartnerService, SubventionUtil, LoanIdResolver, IndianCurrencyPipe,
        LoansAndApplicationsSegregator, BreadcrumbService, PaymentCollectionService, BankAccountService, LoanService
    ]
})
export class BorrowerDashboardModule {
}
